import Select from "@material-ui/core/esm/Select";
import MenuItem from "@material-ui/core/esm/MenuItem";
import Icon from "@material-ui/core/esm/Icon";
import Business from "@material-ui/icons/esm/Business";
import Person from "@material-ui/icons/esm/Person";
import { nanoid } from 'nanoid';
import React, { useState } from 'react';
import { FormProvider } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { CustomerType } from 'api';
import DividerComponent from 'components/Divider/Divider';
import ExternalLink from 'components/ExternalLink/ExternalLink';
import { FormElement } from 'components/Form';
import CheckboxComponent from 'components/Form/Checkbox';
import RouterStepper from 'components/Stepper/RouterStepper';
import { LargeHeader } from 'components/Text';
import useCreateCustomer from 'hooks/customer/useCreateCustomer';
import { CUSTOMERS } from 'routes/customers/paths';
import useNewCustomerForm from 'utils/form/useNewCustomerForm';
import CreateCustomerAddresses from './CreateCustomerAddresses/CreateCustomerAddresses';
import CreateCustomerCompany from './CreateCustomerPersonalia/CreateCustomerCompany';
import CreateCustomerPerson from './CreateCustomerPersonalia/CreateCustomerPerson';
import useStyles from './CreateCustomerStyles';
import { useRecoilValue } from 'recoil';
import { isOrgNumberValid } from 'api/customers/getCustomer';
import CreateCustomerBillingEmail from './CreateCustomerBillingEmail/CreateCustomerBillingEmail';
const idSuffix = nanoid();
export default function CreateCustomer() {
  const {
    t
  } = useTranslation();
  const {
    push
  } = useHistory();
  const {
    icon,
    chooseType
  } = useStyles();
  const newCustomerForm = useNewCustomerForm();
  const {
    getValues,
    formState: {
      isValid
    }
  } = newCustomerForm;
  const {
    createCustomer,
    isLoading
  } = useCreateCustomer();
  const isOrganizationNumberValid = useRecoilValue(isOrgNumberValid);
  const [customerType, setCustomerType] = useState(CustomerType.Person);
  const [accepted, setAccepted] = useState(false);
  return /*#__PURE__*/React.createElement(FormProvider, newCustomerForm, /*#__PURE__*/React.createElement(LargeHeader, null, t('titles.create_new_customer')), /*#__PURE__*/React.createElement(FormElement, {
    title: t('customers.choose_customer_type'),
    childId: `customerType_${idSuffix}`
  }, /*#__PURE__*/React.createElement("div", {
    className: chooseType
  }, /*#__PURE__*/React.createElement(Select, {
    name: "customerType",
    variant: "outlined",
    value: customerType,
    fullWidth: true,
    onChange: e => {
      setCustomerType(e.target.value);
    },
    inputProps: {
      id: `customerType_${idSuffix}`
    }
  }, /*#__PURE__*/React.createElement(MenuItem, {
    value: CustomerType.Person
  }, /*#__PURE__*/React.createElement(Icon, {
    className: icon
  }, /*#__PURE__*/React.createElement(Person, null)), t('customers.private_person')), /*#__PURE__*/React.createElement(MenuItem, {
    value: CustomerType.Company
  }, /*#__PURE__*/React.createElement(Icon, {
    className: icon
  }, /*#__PURE__*/React.createElement(Business, null)), t('customers.business'))))), /*#__PURE__*/React.createElement("form", null, customerType === CustomerType.Person ? /*#__PURE__*/React.createElement(CreateCustomerPerson, null) : /*#__PURE__*/React.createElement(CreateCustomerCompany, null), /*#__PURE__*/React.createElement(CreateCustomerAddresses, null)), /*#__PURE__*/React.createElement(DividerComponent, null), /*#__PURE__*/React.createElement(CreateCustomerBillingEmail, null), /*#__PURE__*/React.createElement(DividerComponent, null), /*#__PURE__*/React.createElement(ExternalLink, {
    link: t('register_vehicle.terms_and_conditions_link')
  }, t('register_vehicle.terms_and_conditions')), /*#__PURE__*/React.createElement(CheckboxComponent, {
    name: "termsAndConditions",
    label: t('customers.terms_and_conditions_label'),
    checked: accepted,
    setChecked: setAccepted
  }), /*#__PURE__*/React.createElement(RouterStepper, {
    onBackButtonClick: () => push(CUSTOMERS),
    onForwardButtonClick: () => createCustomer(getValues(), customerType),
    altForwardButtonText: t('buttons.create_customer'),
    hasForwardButtonDisabled: !isValid || !accepted || isLoading || !isOrganizationNumberValid,
    isForwardButtonLoading: isLoading,
    isFinalStep: true
  }));
}